import * as t from 'io-ts';

import {makeEnumRuntimeType} from '../../../../../../libs/shared/helpers/src/typescript/enumHelpers';
import {RAccount} from '../../../../../models/api/accountModel';
import {RCard} from '../../../../../models/api/cardModel';
import {CrmSyncSourcesEnum} from '../../../../../models/api/crmSyncModel';
import {RAsyncStatus} from '../../../../appTypes';
import {RPanelCancelTokenId} from '../../../panelCancelTokenId';
import {PanelTypesEnum, RCrmPreviewPanelId, RPanelStateBase} from '../../../panelStateBase';

/*
 * Runtime types.
 */

export const RCrmPreviewPanelStateDirty = t.intersection([
  RPanelStateBase,
  t.type({
    id: RCrmPreviewPanelId,
    cancelTokenId: RPanelCancelTokenId,
    type: t.literal(PanelTypesEnum.CRM_PREVIEW),
    crmSyncId: t.number,
    crmSyncSource: makeEnumRuntimeType(CrmSyncSourcesEnum),
    mapping: t.record(t.string, t.Integer),
  }),
  t.partial({
    status: RAsyncStatus,
    accounts: t.readonlyArray(RAccount),
    cards: t.readonlyArray(RCard),
    selectedId: t.number,
    externalListId: t.string,
  }),
]);

/*
 * Types.
 */

export interface CrmPreviewPanelState extends Readonly<t.TypeOf<typeof RCrmPreviewPanelStateDirty>> {}
export const RCrmPreviewPanelState = t.clean<CrmPreviewPanelState>(RCrmPreviewPanelStateDirty as any);
